module.exports = __webpack_public_path__ + "img/article613.0306cd26.jpg";